// extracted by mini-css-extract-plugin
export default {"settings_section":"settings_settings_section__JgghN","settings_panel_show":"settings_settings_panel_show__b6Ikp"};